import type { ReactNode } from 'react';

type TDetailRowProps = {
  label: string;
  value: ReactNode;
  adornment?: ReactNode;
};

export const DetailRow = ({ label, value, adornment }: TDetailRowProps) => (
  <div className="tw-flex tw-flex-col tw-cds-gap-1">
    <span className="tw-cds-font-subtitle-01 tw-cds-text-default">{label}</span>
    <span className="tw-flex tw-items-center tw-cds-gap-2 tw-cds-font-body-02 tw-cds-text-subtle">
      {value}
      {adornment}
    </span>
  </div>
);
